import { CardContent as NovaCardContent, CardContentProps as NovaCardContentProps } from '@fme-nova/components'
import { CardContentProps as MuiCardContentProps, default as MuiCardContent } from '@mui/material/CardContent'

import { createComponentWrapperWithRef } from '../../theme'

export const CardBody = createComponentWrapperWithRef<MuiCardContentProps | NovaCardContentProps>(
  {
    mui: MuiCardContent,
    nova: NovaCardContent,
  },
  'CardBody',
)
